import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Layout.css'; // Assuming you have a CSS file for additional styling

const Layout = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="layout">
      <header className="navbar">
        <div className="navbar-brand">
          <h2>Utkarsh Srivastava</h2>
        </div>
        <button className="navbar-toggler" onClick={toggleMenu}>
          ☰
        </button>
        <nav className={`navbar-menu custom-navbar ${isMenuOpen ? 'is-active' : ''}`}>
          <Link to="/" onClick={toggleMenu} className={location.pathname === '/' ? 'active' : ''}>Home</Link>
          <Link to="/profile" onClick={toggleMenu} className={location.pathname === '/profile' ? 'active' : ''}>Profile</Link>
          <Link to="/projects" onClick={toggleMenu} className={location.pathname === '/projects' ? 'active' : ''}>Projects</Link>
          <Link to="/learnings" onClick={toggleMenu} className={location.pathname === '/learnings' ? 'active' : ''}>Learnings</Link>
          <Link to="/certifications" onClick={toggleMenu} className={location.pathname === '/certifications' ? 'active' : ''}>Certifications</Link>
          <Link to="/ideas" onClick={toggleMenu} className={location.pathname === '/ideas' ? 'active' : ''}>Ideas</Link>
          <Link to="/contact-me" onClick={toggleMenu} className={location.pathname === '/contact-me' ? 'active' : ''}>Contact Me</Link>
        </nav>
      </header>
      <main>{children}</main>
    </div>
  );
};

export default Layout;